import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 静态路由（不需要权限）
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('../views/login/Login.vue'),
    hidden: true
  }
]

const router = new VueRouter({
  // mode: 'history',
  routes: constantRoutes
})

export default router
